import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmmaterialinfo/cecUnmMaterialInfo/import',
      method: 'post',
      data: data
    })
  }
}
